/* eslint-disable */
import { defineCustomElement } from "vue";
import template from "./vue-template.hbs";
import "./index.scss";

const HTTP_STATUS_NO_CONTENT = 204;

const BfvSearch = defineCustomElement({
  props: {
    dataTextSearchUrl: String,
    dataInputPlaceholder: String,
    dataBtnText: String,
  },
  data() {
    return {
      responseData: { results: [] },
      errorOccured: false,
      searchStarted: false,
      searching: false,
      placeholder: "",
    };
  },
  mounted() {
    this.placeholder = this.dataInputPlaceholder;
  },
  template,
  methods: {
    search(event) {
      // state handling
      this.searchStarted = true;
      this.searching = true;

      event.preventDefault();

      const searchString = document.getElementById("input-search").value;
      const url = this.dataTextSearchUrl;
      const request = url + "?query=" + searchString;

      const requests = [
        fetch(request).then((resp) => {
          if (resp.status === HTTP_STATUS_NO_CONTENT) {
            // empty result
            return [];
          } else if (!resp.ok) {
            // Handle error responses (401, 403, 500, etc.)
            throw new Error(`HTTP ${resp.status}: ${resp.statusText}`);
          } else {
            return resp.json();
          }
        }),
      ];

      return Promise.all(requests).then(
        (dataList) => {
          const results = dataList[0];

          this.responseData = { results };
          this.searching = false;
        },
        (response) => {
          this.errorOccured = true;
          console.error("failed", response);

          this.responseData = { results: [] };
          this.searching = false;
        },
      );
    },
  },
  // Disable shadow DOM to avoid CSS encapsulation issues
  shadowRoot: false,
});

// For dynamic SFC loading
window.bfvSfc = window.bfvSfc || {};
window.bfvSfc["bfv-search"] = BfvSearch;

export default BfvSearch;

